import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
const getSubscriptionCycles = async (subscriptionId: string) => {
  const url = `${ENDPOINTS.SUBSCRIPTIONS}/${subscriptionId}/cycles`
  const { data } = await api.get<SubscriptionCycleResponseType>(url)
  return data
}
const useSubscriptionCycles = (subscriptionId: string) => {
  return useQuery({
    queryKey: [`ENDPOINTS.SUBSCRIPTION/${subscriptionId}/cycles`],
    queryFn: () => getSubscriptionCycles(subscriptionId),
  })
}
export default useSubscriptionCycles
